<template>
    <div class="edu-mon-wrap">
      <Header />
      <div class="edu-mon-wrap__banner">
        <img src="../../assets/P-1.png" />
      </div>
      <div class="edu-mon-wrap__content">
        <div class="edu-mon-wrap__content-title">
          <h2>
              全国防范非法证券期货宣传月
          </h2>
        </div>
        <div>
          <h2>投资理财不受骗，查清资质是关键</h2>
        </div>
        <div class="edu-mon-wrap__content-img">
            <img src="../../assets/eduDetail.png" alt="" srcset="">
        </div>
      </div>
      <Footer />
    </div>
  </template>
    
    <script>
  import Header from "../header";
  import Footer from "../footer";
  
  export default {
    name: "EduMon",
    data() {
      return {};
    },
    methods: {},
    components: {
      Header,
      Footer,
    },
  };
  </script>
    
    <style scoped lang="scss">
  .edu-mon-wrap {
    min-height: 100%;
    background: rgba(245, 245, 245, 1);
    padding-top: 6rem;
  
    &__banner {
      img {
        width: 100%;
        margin-bottom: 0;
      }
    }
    &__content {
      width: 75rem;
      margin: 0 auto;
      padding: 3.13rem 6.26rem;
      padding-bottom: 180px;
      background-color: #fff;
      margin-top: 0.1rem;
      text-align: center;
      color: #323232;
      font-size: 1rem;
      overflow: hidden;
      &-title {
        color: red;
        margin-bottom: 1rem;
      }
      &-img {
        margin-top: 15px;
        img {
          width: 100%;
        }
      }
    }
  }
  </style>
    


// WEBPACK FOOTER //
// src/components/EduMon/EduMon.vue